module.exports = __webpack_public_path__ + "themes/fq/img/frame-center@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame-center@2x.png
// module id = 10
// module chunks = d-game